<template>
  <v-dialog :value="value" max-width="900" @input="$emit('input', $event)">
    <!-- A photo rarely matches the dialog's shape, so grey fills the gap either side of
         it. Transparent let the dimmed page show through, which read as a rendering fault. -->
    <v-card flat color="grey darken-3" @click="$emit('input', false)">
      <v-img :src="src" contain max-height="85vh" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "PhotoLightbox",
  props: {
    value: Boolean,
    src: String,
  },
});
</script>
